(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fye-bespoke-cta"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-fye-kl-form]');
  if (!btn) return;
  e.preventDefault();
  window._klOnsite = window._klOnsite || [];
  window._klOnsite.push(['openForm', btn.getAttribute('data-fye-kl-form')]);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fye-testimonials"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSlider(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll(".fye-testimonials__slide"));
    var dotsWrap = root.querySelector(".fye-testimonials__dots");
    if (slides.length === 0) return;
    var index = 0, dots = [];
    if (dotsWrap) {
      dotsWrap.innerHTML = "";
      slides.forEach(function (_, i) {
        var dot = document.createElement("button");
        dot.type = "button";
        dot.className = "fye-testimonials__dot";
        dot.setAttribute("aria-label", "Show testimonial " + (i + 1));
        dot.addEventListener("click", function () { goTo(i, true); });
        dotsWrap.appendChild(dot);
        dots.push(dot);
      });
    }
    function goTo(next, stopAuto) {
      index = (next + slides.length) % slides.length;
      slides.forEach(function (s, i) {
        s.classList.toggle("is-active", i === index);
        s.setAttribute("aria-hidden", i === index ? "false" : "true");
      });
      dots.forEach(function (d, i) {
        d.classList.toggle("is-active", i === index);
        d.setAttribute("aria-current", i === index ? "true" : "false");
      });
      if (stopAuto) stopAutoplay();
    }
    var autoMs = parseInt(root.getAttribute("data-autoplay"), 10);
    var timer = null;
    function startAutoplay() {
      if (!autoMs || autoMs < 1000 || slides.length < 2) return;
      stopAutoplay();
      timer = setInterval(function () { goTo(index + 1, false); }, autoMs);
    }
    function stopAutoplay() { if (timer) { clearInterval(timer); timer = null; } }
    root.addEventListener("mouseenter", stopAutoplay);
    root.addEventListener("mouseleave", startAutoplay);
    root.setAttribute("tabindex", "0");
    root.addEventListener("keydown", function (e) {
      if (e.key === "ArrowLeft") goTo(index - 1, true);
      if (e.key === "ArrowRight") goTo(index + 1, true);
    });
    var startX = null;
    root.addEventListener("touchstart", function (e) { startX = e.touches[0].clientX; }, { passive: true });
    root.addEventListener("touchend", function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) goTo(index + (dx < 0 ? 1 : -1), true);
      startX = null;
    }, { passive: true });
    goTo(0, false);
    startAutoplay();
  }
  function initAll() {
    document.querySelectorAll(".fye-testimonials").forEach(function (el) { initSlider(el); });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else { initAll(); }
  window.FYETestimonials = { init: initSlider, initAll: initAll };
  document.addEventListener("shopify:section:load", function (e) {
    var root = e.target.querySelector(".fye-testimonials");
    if (root) initSlider(root);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
